
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';

    @Component({})
    export default class CustomRoomsValueQuestion extends Vue {
        @Prop() public question: Question;
        public optionId?: number = 0;
        public propertyValue = 0;
        public rooms= {
            bedrooms: {
                number: 0,
                value: 0,
                singleValue: 1000000,
                expanded: false,
                label: 'Chambre',
                plural: 's',
                details: [
                    {
                        title: 'bed',
                        label: 'Lit',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'closet',
                        label: 'Armoire',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'chair',
                        label: 'Fauteuil',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'other',
                        label: 'Autres',
                        number: 0,
                        value: 0,
                    }
                ],
            },
            livingRooms: {
                number: 0,
                value: 0,
                singleValue: 2500000,
                expanded: false,
                changeMode: false,
                label: 'Salon',
                plural: 's',
                details: [
                    {
                        title: 'sofa',
                        label: 'Canapé',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'television',
                        label: 'TV',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'home-cinema',
                        label: 'Home cinema',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'game-console',
                        label: 'Console',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'other',
                        label: 'Autres',
                        number: 0,
                        value: 0,
                    }
                ],
            },
            diningRooms: {
                number: 0,
                value: 0,
                singleValue: 700000,
                expanded: false,
                label: 'Salle à manger',
                plural: '',
                details: [
                    {
                        title: 'fridge',
                        label: 'Refrigérateur',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'stove',
                        label: 'Four',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'cooker',
                        label: 'Cuisinière',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'other',
                        label: 'Autres',
                        number: 0,
                        value: 0,
                    }
                ],
            },
            offices: {
                number: 0,
                value: 0,
                singleValue: 1000000,
                expanded: false,
                label: 'Bureau',
                plural: 'x',
            },
            fancyThings: {
                number: 0,
                value: 0,
                singleValue: 300000,
                expanded: false,
                label: 'Objets de valeur',
                plural: '',
                details: [
                    {
                        title: 'electronics',
                        label: 'Electronique',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'jewels',
                        label: 'Bijoux',
                        number: 0,
                        value: 0,
                    },
                    {
                        title: 'other',
                        label: 'Autres trésors',
                        number: 0,
                        value: 0,
                    }
                ],
            },

        };

        public recalculatePropertyValue(typeOfRoom: string) {
            this.updatePropertyValue(true);
            this.recalculateDetailsValue(typeOfRoom);
        }

        public recalculateDetailsValue(typeOfRoom: string) {
            if(this.rooms[typeOfRoom].hasOwnProperty('details')){

                let otherDetailValue = parseInt(this.rooms[typeOfRoom].value + '');
                let otherKey: number = -1;
                let roomValueChanged = false;
                for(let key in this.rooms[typeOfRoom].details){
                    if (this.rooms[typeOfRoom].details[key].title === 'other') {
                        otherKey = parseInt(key);
                        continue;
                    }
                    let detailValue = parseInt(this.rooms[typeOfRoom].details[key].value + '') ;
                    otherDetailValue = otherDetailValue - detailValue;
                    let detailNumber = parseInt(this.rooms[typeOfRoom].details[key].number + '');
                    if (detailNumber === 0 && detailValue > 0) {
                        this.rooms[typeOfRoom].details[key].number = 1;
                    }
                    if (otherDetailValue < 0) {
                        this.rooms[typeOfRoom].value = parseInt(this.rooms[typeOfRoom].value + '')  + ( otherDetailValue * -1 );
                        otherDetailValue = 0;
                        roomValueChanged = true;
                    }
                }

                if(otherKey != -1){
                    this.rooms[typeOfRoom].details[otherKey].value = otherDetailValue;
                }
                if (roomValueChanged) {
                    this.updatePropertyValue(true);
                }

            }
        }


        public increase(typeOfRoom){
            this.rooms[typeOfRoom].number++;
            this.rooms[typeOfRoom].value = this.rooms[typeOfRoom].number * this.rooms[typeOfRoom].singleValue;
            this.recalculatePropertyValue(typeOfRoom);
        }
        public decrease(typeOfRoom){

            if(this.rooms[typeOfRoom].number === 0){
                return;
            }
            this.rooms[typeOfRoom].number--;
            this.rooms[typeOfRoom].value = this.rooms[typeOfRoom].number * this.rooms[typeOfRoom].singleValue;
            this.recalculatePropertyValue(typeOfRoom);
        }

        hideDetails(typeOfRoom) {
            this.rooms[typeOfRoom].expanded = false;
        }
        showDetails(typeOfRoom) {
            if(this.rooms[typeOfRoom].expanded === true){
                return;
            }
            for(let roomType in this.rooms){
                this.rooms[roomType].expanded = false;
            }
            this.rooms[typeOfRoom].expanded = true;
        }



        respond() {
            this.question.currentResponse!.value = this.propertyValue + '';
            this.question.currentResponse!.customData = this.rooms;
            this.question.validate();
            this.question.changedEvent.emit('changed');
        }

        updatePropertyValue(respond = false) {
            this.propertyValue = parseInt(this.rooms.livingRooms.value + '')  + parseInt(this.rooms.bedrooms.value + '')  + parseInt(this.rooms.diningRooms.value + '')  + parseInt(this.rooms.offices.value + '') + parseInt(this.rooms.fancyThings.value + '') ;
            console.log(respond);
            if(respond){
                this.respond();
            }
        }
        public updateResponse(option: any){
            // this.question.currentResponse!.value = option!.code;
            // this.question.currentResponse!.valueId = option!.id;
            // this.question.changedEvent.emit('changed');
            // this.question.validate();
            // this.optionId = option!.id;
        }

        public mounted() {
            this.question.extraEvent.on(() => {
                const payload = this.$store.state.modalPayload;
                if (payload.type === 'mrh-room-detail') {
                    this.rooms[payload.key] = payload.content;
                }
                this.updatePropertyValue(true);

            });
            const question = this.$store.getters.getQuestion(30);
            const answer = this.question.currentResponse!;

            if (answer.customData) {
                for (let type in this.rooms) {
                    if(answer.customData.hasOwnProperty(type)){
                        this.rooms[type] = answer.customData[type];
                    }
                }
                this.updatePropertyValue();
            }else{
                if (typeof undefined != typeof question) {
                    const currentResponse = question.currentResponse;

                    if(currentResponse.value < 2){
                        this.rooms.bedrooms.number = currentResponse.value;
                    }
                    if( currentResponse.value >= 2 && currentResponse.value <= 5 ){
                        this.rooms.livingRooms.number = 1;
                        this.rooms.bedrooms.number = (<number>currentResponse.value) - 1;
                    }
                    if (currentResponse.value > 5) {
                        this.rooms.livingRooms.number = 2;
                        this.rooms.bedrooms.number = (<number>currentResponse.value) - 2;
                    }
                    for (let roomType in this.rooms) {
                        this.rooms[roomType].value = this.rooms[roomType].number * this.rooms[roomType].singleValue;
                        this.recalculatePropertyValue(roomType);
                    }
                }
            }


        }

    }
